<template>
  <v-menu
    offset-x
    offset-y
    close-on-click
    close-on-content-click
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="primary"
        dark
        v-bind="attrs"
        v-on="on"
      >
        AÇÕES
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="(action, index) in showLoteActions"
        :key="index"
        :disabled="action.disabled"
        @click="action.onClick"
      >
        <v-list-item-title>{{ action.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { conciliacaoClient } from '../../../libs'

export default {
  props: {
    lote: Object,
    isUsuarioTradimus: Boolean
  },
  data() {
    return {
      userId: null,
    }
  },
  computed: {
    loteActions() {
      return [
        {
          title: 'Finalizar conciliação',
          onClick: this.handleFinalizarConciliacaoClick,
          disabled: !this.$props.lote?.acoes?.includes('FinalizarConciliacaoManual'),
          showCliente: true
        },
        {
          title: 'Voltar para conciliação manual',
          onClick: this.handleConciliacaoManualClick,
          disabled: !this.$props.lote?.acoes?.includes('ConciliarManualmente'),
          showCliente: true
        },
        {
          title: 'Assumir como responsável',
          onClick: this.handleResponsavelClick,
          disabled: !this.$props.lote?.acoes?.includes('AssumirComoResponsavel'),
          showCliente: true
        },
        {
          title: 'Limpar responsáveis',
          onClick: this.handleRemoveResponsavelClick,
          disabled: !this.$props.lote?.acoes?.includes('RemoverResponsavel'),
        },
        {
          title: 'Baixar planilha de resultados',
          onClick: this.handleDownloadPlanilhaResultados,
        },
        {
          title: 'Ir para tela de conciliação manual',
          onClick: this.handleClickTelaConciliacaoManual
        }
      ]
    },
    showLoteActions () {
      return this.loteActions.filter(loteActions => this.isUsuarioTradimus ? loteActions : loteActions.showCliente)
    }
  },
  methods: {
    async handleFinalizarConciliacaoClick () {
      try {
        const command = {
          pagamentoId: this.$props.lote.pagamentoId,
          pagamentoLoteIds: [this.$props.lote.id]
        }
        await conciliacaoClient.pagamentoLote.finalizarConciliacoesManuais(command)
      } catch (error) {
        window.alert('Erro ao finalizar conciliação')
      }
    },
    async handleConciliacaoManualClick () {
      try {
        const command = {
          pagamentoId: this.$props.lote.pagamentoId,
          pagamentoLoteIds: [this.$props.lote.id]
        }
        await conciliacaoClient.pagamentoLote.iniciarConciliacoesManuais(command)
        this.$emit('updateLote')
      } catch (error) {
        window.alert('Erro ao voltar para conciliação manual')
      }
    },
    async handleResponsavelClick () {
      try {
        const command = {
          pagamentoId: this.$props.lote.pagamentoId,
          responsavelId: this.userId,
          pagamentoLoteIds: [this.$props.lote.id]
        }
        await conciliacaoClient.pagamentoLote.updateResponsaveis(command)
        this.$emit('updateLote')
      } catch (error) {
        window.alert('Erro ao assumir como responsável')
      }
    },
    async handleRemoveResponsavelClick () {
      try {
        const command = {
          pagamentoId: this.$props.lote.pagamentoId,
          responsavelId: null,
          pagamentoLoteIds: [this.$props.lote.id]
        }
        await conciliacaoClient.pagamentoLote.updateResponsaveis(command)
        this.$emit('updateLote')
      } catch (error) {
        window.alert('Erro ao remover responsável')
      }
    },
    async handleDownloadPlanilhaResultados () {
      const userData = JSON.parse(sessionStorage.getItem('userData'))
      try {
        const blob = await conciliacaoClient.pagamento.downloadPagamentoPlanilhaResultados(
          this.$props.lote.pagamentoId,
          {
            grupoEconomicoId: userData.grupo_economico,
            pagamentoLoteId: this.$props.lote.id
          }
          )
        const href = URL.createObjectURL(blob)

        // https://stackoverflow.com/questions/43912862/axios-expose-response-headers-content-disposition
        // Para ler o nome do arquivo gerado pelo back, é preciso alterar a API para expor um header
        const filename = `Planilha de resultados-${new Date().getTime()}.xlsx`

        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
      } catch (error) {
        window.alert('Erro ao baixar planilha')
      }
    },
    handleClickTelaConciliacaoManual () {
      this.$router.push(`/recebiveis/pagamentos/${this.lote.pagamentoId}/${this.lote.id}/conciliacao-manual`)
    }
  },
  async mounted () {
    const signedUser = await conciliacaoClient.authentication.getSignedUser()

    if (signedUser) {
      this.userId = signedUser.id
    }
  }
}
</script>
